<template>
  <div class="cover">
    <div class="main-container">
      <div class="mask-wrapper">
        <div class="mask-container">
          <img :src="field.value.image" alt="" v-scroll-animate>
        </div>
      </div>
      <div class="logo-wrapper">
        <div class="logo-box" v-scroll-animate>
          <div class="logo-container">
            <div class="asset-container">
              <img src="./../../assets/logo/seu-logo-name.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cover',
  props: {
    field: {
      type: Object
    }
  },


}
</script>

<style lang="scss">
@import "Cover.scss";
</style>
